import { DisinfectionInstructions } from '@/common/interface/instruction.model';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DisinfectionprogramService } from '@services/disinfectionprogram.service';
import { LoaderService } from '@services/loader.service';
import { PlacementService } from '@services/placement.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-active-disinfection-program',
  templateUrl: './active-disinfection-program.component.html',
  styleUrl: './active-disinfection-program.component.scss'
})
export class ActiveDisinfectionProgramComponent {
  @Input() placementId: number | null = null;
  @Input() disInfectionType: number | null = null;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  disinfectionForm: FormGroup;
  instructionsEnum = DisinfectionInstructions;
  selectedInstructions: string[] = [];
  instructionKeys: { instruction: string, isChecked: boolean }[] = [];
  public isAuthLoading = false;
  public isLoading$: Observable<boolean>;

  constructor(
    private fb: FormBuilder,
    private placementService: PlacementService,
    private disInfectionService:DisinfectionprogramService,
    private toastr: ToastrService,
    private router: Router,
    private loaderService: LoaderService
  ) {
    //this.instructionKeys = Object.keys(this.instructionsEnum);
  }

  ngOnInit(): void {
    console.log(this.disInfectionType);
    this.disinfectionForm = this.fb.group({
      instructions: this.fb.array([], [Validators.required, this.atLeastOneCheckboxSelected])
    });
    this.getInstructionList();

  }

  getInstructionList() {
    // Fetch all available instructions
    this.disInfectionService.getDisInfectionInstructionList(this.disInfectionType).subscribe(result => {
      // Initialize the instruction keys
      this.instructionKeys = result.map(instruction => ({ instruction, isChecked: false }));

      // Fetch existing instructions for this placement
      this.placementService.getActivePlacementDisinfectionlist(this.placementId).subscribe(existingInstructions => {
        // Mark existing instructions as checked
        existingInstructions.forEach(existing => {
          const instructions = existing.instruction.split(',');
          instructions.forEach(inst => {
            const foundInstruction = this.instructionKeys.find(i => i.instruction.trim() === inst.trim());
            if (foundInstruction) {
              foundInstruction.isChecked = true;
              this.addInstructionControl(foundInstruction.instruction); // Add to form array
            }
          });
        });
      });
    });
  }

  addInstructionControl(instruction: string) {
    const instructionsArray: FormArray = this.disinfectionForm.get('instructions') as FormArray;
    instructionsArray.push(this.fb.control(instruction));
  }

  onCheckboxChange(e) {
    const instructionsArray: FormArray = this.disinfectionForm.get('instructions') as FormArray;

    if (e.target.checked) {
      instructionsArray.push(this.fb.control(e.target.value));
    } else {
      const index = instructionsArray.controls.findIndex(x => x.value === e.target.value);
      instructionsArray.removeAt(index);
    }
  }

  isChecked(instruction: string): boolean {
    const instructionsArray: FormArray = this.disinfectionForm.get('instructions') as FormArray;
    return instructionsArray.controls.some(control => control.value === instruction);
}

  atLeastOneCheckboxSelected(formArray: FormArray) {
    return formArray.length > 0 ? null : { required: true };
  }
  // Form submission handler
  onSubmit() {
    this.loaderService.showLoader();
    this.isAuthLoading = true;
    // this.markFormGroupTouched(this.bodyWeightForm);
    if (this.disinfectionForm.valid) {
      const selectedInstructions = this.disinfectionForm.value.instructions;

      // Prepare the payload to match your backend model
      const payload = {
        placementId: this.placementId, // Assuming a placementId; replace it with the actual value
        instructions: selectedInstructions.map(instruction => ({ instruction }))
      };
      this.placementService.addActivePlacementDisinfectionInstruction(payload).subscribe({
        next: (response) => {
          setTimeout(() => {
            this.isAuthLoading = false;
            this.loaderService.hideLoader();
            this.toastr.success("Instruction Added Successfully");
            this.close.emit(); 
          }, 2000);
          
        },
        error: (error) => {
          setTimeout(() => {
            this.isAuthLoading = false;
            this.loaderService.hideLoader();
            // Handle login error
            this.toastr.error("Instructions Not Added");

          }, 2000);
        }
      });

    }
    else {
      this.disinfectionForm.markAllAsTouched();
      this.isAuthLoading = false;
      this.loaderService.hideLoader();
    }


  }
}
